/* GOOSEKET product detail interactions — guarded, page-scoped edition.
 * Requires Swiper 10 classic library for .swiper sliders; AIR+ swiper-element loads separately.
 * Install only on product pages. Keep the original detail.js as a backup.
 */
(() => {
  'use strict';
  if (window.__gooseketDetailSafeLoaded) return;
  window.__gooseketDetailSafeLoaded = true;

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const hasClassicSwiper = () => typeof window.Swiper === 'function';
  const clampPercent = (current, total) => total > 0 ? Math.min(100, Math.max(0, current / total * 100)) : 0;
  const setBar = (el, current, total) => { if (el) el.style.width = `${clampPercent(current, total)}%`; };
  const classicInit = (el, options) => {
    if (!el || !hasClassicSwiper()) return null;
    if (el.swiper) return el.swiper;
    return new window.Swiper(el, options);
  };
  const whenReady = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

  const colorMap = {
    beige: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-beige.jpg)', name: ' ベージュ' },
    gray: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-gray.jpg)', name: ' グレー' },
    mint: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-mint.jpg)', name: ' ミント' },
    khaki: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-khaki.jpg)', name: ' カーキ' },
    bk: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-black.jpg)', name: ' ブラック' },
    zebra: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/zebra_2c186bb6-337e-4276-900f-32f1196e5ce5.jpg)', name: ' ゼブラ' },
    bleo: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/brown-leopard_d51a4ff1-4eeb-41ce-8ebe-fc425132fab7.jpg)', name: ' ブラウンレオパード' },
    gleo: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/gray-leopard_dabcaa90-d935-4442-89f1-781b4c9ec972.jpg)', name: ' グレー レオパード' }
  };

  function init365PlusColorGallery() {
    const slides = $('#slideContainer');
    const bar = $('#progressBar');
    const display = $('#selectedColor');
    const slider = $('.colorSwiper');
    if (!slides || !bar || !display || !slider || slider.hasAttribute('data-color') || !hasClassicSwiper()) return;
    // The same .color-circle class is used by other products; limit this gallery to data-color entries.
    const chips = $$('.color-circle[data-color]').filter(chip => colorMap[chip.dataset.color]);
    if (!chips.length) return;
    const render = color => {
      const info = colorMap[color];
      if (!info) return;
      if (slider.swiper) slider.swiper.destroy(true, true);
      slides.replaceChildren();
      for (let i = 1; i <= 6; i++) {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        const img = document.createElement('img');
        img.src = `https://gooseket.com/web/upload/product_detail/365plus/colorchip/365plus_${color}${String(i).padStart(2, '0')}.jpg`;
        img.alt = `${color}-${i}`;
        img.loading = 'lazy';
        slide.appendChild(img);
        slides.appendChild(slide);
      }
      const instance = classicInit(slider, {
        loop: false, slidesPerView: 1.5, spaceBetween: 10, grabCursor: true, allowTouchMove: true,
        on: { slideChange() { setBar(bar, this.realIndex + 1, this.slides.length); } }
      });
      if (instance) setBar(bar, 1, instance.slides.length);
      display.replaceChildren();
      const chip = document.createElement('div');
      chip.className = 'chip';
      chip.style.backgroundImage = info.bg;
      chip.style.backgroundSize = 'cover';
      const name = document.createElement('span');
      name.textContent = info.name;
      display.append(chip, name);
      chips.forEach(el => el.classList.toggle('active', el.dataset.color === color));
    };
    chips.forEach(chip => {
      const info = colorMap[chip.dataset.color];
      chip.style.backgroundImage = info.bg;
      chip.style.backgroundSize = 'cover';
      chip.style.backgroundPosition = 'center';
      chip.addEventListener('click', () => render(chip.dataset.color));
    });
    render(chips.find(chip => chip.classList.contains('active'))?.dataset.color ||
      (chips.some(chip => chip.dataset.color === 'bk') ? 'bk' : chips[0].dataset.color));
  }

  function initClassicSliders() {
    if (!hasClassicSwiper()) return;
    $$('.structure-swiper').forEach(el => classicInit(el, {
      slidesPerView: 1.5, spaceBetween: 20, grabCursor: true, loop: false,
      centeredSlides: false, slidesOffsetAfter: 40
    }));
    const configs = [
      ['.customSingleSlideSwiper', '#customProgressBar'],
      ['.customSingleSlideSwiper2', '#progressBarSliderOnly'],
      ['.introSwiper', '#introProgressBar']
    ];
    configs.forEach(([selector, barSelector]) => {
      $$(selector).forEach(el => {
        const bar = $(barSelector);
        const update = sw => setBar(bar, sw.activeIndex + 1, sw.slides.length);
        const instance = classicInit(el, {
          slidesPerView: 1, loop: false, spaceBetween: 10, grabCursor: true,
          on: { init() { update(this); }, slideChange() { update(this); } }
        });
        if (instance) update(instance);
      });
    });
    $$('.airHeroSwiper').forEach(el => classicInit(el, {
      slidesPerView: 1, loop: true, speed: 600,
      pagination: { el: '.airHeroPagination', clickable: true }
    }));
    $$('.airUseSwiper').forEach(el => classicInit(el, { slidesPerView: 1.25, spaceBetween: 10 }));
  }

  function initSimpleImageColorChips() {
    // Sling bag cutout image: only chips with data-img belong to this interaction.
    const image = $('#mainImage');
    const display = $('#selectedColor');
    const displayChip = display && $('.chip', display);
    const displayName = display && $('span', display);
    const chips = $$('.color-circle[data-img]');
    if (image && displayChip && displayName) {
      chips.forEach(chip => chip.addEventListener('click', () => {
        chips.forEach(c => c.classList.remove('active'));
        chip.classList.add('active');
        if (chip.dataset.img) image.src = chip.dataset.img;
        if (chip.dataset.hex) displayChip.style.background = chip.dataset.hex;
        displayName.textContent = chip.dataset.name || '';
      }));
    }
    const imageTop = $('#mainImageTop');
    const topDisplay = $('#selectedColorTop');
    const topChip = topDisplay && $('.chip-top', topDisplay);
    const topName = topDisplay && $('span', topDisplay);
    const topChips = $$('.color-circle-top');
    if (imageTop && topChip && topName) {
      topChips.forEach(chip => chip.addEventListener('click', () => {
        topChips.forEach(c => c.classList.remove('active'));
        chip.classList.add('active');
        if (chip.dataset.img) imageTop.src = chip.dataset.img;
        if (chip.dataset.hex) topChip.style.background = chip.dataset.hex;
        topName.textContent = chip.dataset.name || '';
      }));
    }
  }

  function init365ColorSliders() {
    if (!hasClassicSwiper()) return;
    const elements = $$('.swiper.colorSwiper[data-color]');
    if (!elements.length) return;
    const instances = new Map();
    elements.forEach(el => {
      const color = el.dataset.color;
      const bar = $(`.progress-bar-container[data-color="${CSS.escape(color)}"] .progress-bar-fill`);
      const update = sw => setBar(bar, sw.activeIndex, Math.max(1, sw.slides.length - 1));
      const instance = classicInit(el, {
        slidesPerView: 1.5, spaceBetween: 10, centeredSlides: false,
        on: { init() { update(this); }, slideChange() { update(this); } }
      });
      if (instance) instances.set(color, instance);
    });
    const chips = $$('.color-chip[data-color]');
    chips.forEach(chip => chip.addEventListener('click', () => {
      const color = chip.dataset.color;
      chips.forEach(c => c.classList.toggle('active', c === chip));
      elements.forEach(el => { el.style.display = el.dataset.color === color ? 'block' : 'none'; });
      $$('.progress-bar-container[data-color]').forEach(el => {
        el.style.display = el.dataset.color === color ? 'block' : 'none';
      });
      const instance = instances.get(color);
      if (instance) { instance.update(); instance.slideTo(0); }
    }));
    const initial = chips.find(c => c.classList.contains('active')) || chips[0];
    if (initial) initial.click();
  }

  function init365WrappedColorSliders() {
    if (!hasClassicSwiper()) return;
    $$('.color_slide_365-wrap').forEach(container => {
      const instances = new Map();
      $$('.color_slide_365-swiper', container).forEach(el => {
        const color = el.dataset.color;
        const bar = $('.color_slide_365-progress-fill', el.nextElementSibling || document.createElement('div'));
        const update = sw => setBar(bar, sw.activeIndex, Math.max(1, sw.slides.length - 1));
        const instance = classicInit(el, {
          slidesPerView: 1.5, spaceBetween: 10, centeredSlides: false,
          on: { init() { update(this); }, slideChange() { update(this); } }
        });
        if (instance) instances.set(color, instance);
      });
      const chips = $$('.color_slide_365-chip', container);
      chips.forEach(chip => chip.addEventListener('click', () => {
        const color = chip.dataset.color;
        chips.forEach(c => c.classList.toggle('active', c === chip));
        $$('.color_slide_365-swiper', container).forEach(el => {
          el.style.display = el.dataset.color === color ? 'block' : 'none';
        });
        $$('.color_slide_365-progress', container).forEach(el => {
          el.style.display = el.previousElementSibling?.dataset.color === color ? 'block' : 'none';
        });
        const instance = instances.get(color);
        if (instance) { instance.update(); instance.slideTo(0); }
        const label = $('.color_slide_365-label', container);
        if (label) label.textContent = color;
      }));
      const first = chips.find(c => c.classList.contains('active')) || chips[0];
      if (first) first.click();
    });
  }

  function initAccordions() {
    $$('.accordion').forEach(acc => {
      if (acc.dataset.gooseketAccordionReady) return;
      const panel = acc.nextElementSibling;
      if (!panel) return;
      acc.dataset.gooseketAccordionReady = 'true';
      acc.addEventListener('click', () => {
        acc.classList.toggle('active');
        panel.style.maxHeight = panel.style.maxHeight ? '' : `${panel.scrollHeight}px`;
      });
    });
  }

  function initVideoAutoplay() {
    // Only videos inside product detail areas; avoid controlling theme hero/app videos.
    const root = $('#prdDetailWrapAll_new') || $('.prdDetailWrap') || $('.prdDetailWrapAll');
    if (!root || typeof IntersectionObserver === 'undefined') return;
    const videos = $$('video', root);
    if (!videos.length) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.4) {
          video.play().catch(() => {});
        } else if (!entry.isIntersecting || entry.intersectionRatio <= 0.15) {
          video.pause();
        }
      });
    }, { threshold: [0, 0.15, 0.4, 1] });
    videos.forEach(video => {
      if (video.dataset.gooseketVideoReady) return;
      video.dataset.gooseketVideoReady = 'true';
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'metadata');
      observer.observe(video);
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) videos.forEach(v => v.pause());
    });
  }

  function initAirPlus() {
    const root = $('#prdDetailWrapAll_new');
    if (!root) return;
    const swiperUrl = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-element-bundle.min.js';
    const scriptId = 'gooseket-airplus-swiper-element';
    function loadSwiperElement() {
      if (customElements.get('swiper-container')) return Promise.resolve();
      return new Promise((resolve, reject) => {
        let script = document.getElementById(scriptId);
        if (!script) {
          script = document.createElement('script');
          script.id = scriptId;
          script.src = swiperUrl;
          script.async = true;
          document.head.appendChild(script);
        }
        const timer = setTimeout(() => reject(new Error('Swiper Element loading timed out')), 12000);
        const complete = () => customElements.whenDefined('swiper-container').then(() => { clearTimeout(timer); resolve(); });
        if (customElements.get('swiper-container')) complete();
        else {
          script.addEventListener('load', complete, { once: true });
          script.addEventListener('error', () => { clearTimeout(timer); reject(new Error('Swiper Element could not load')); }, { once: true });
        }
      });
    }
    function initializeSliders() {
      $$('.newMySwiper5, .newMySwiper3', root).forEach(el => {
        if (el.swiper || el.dataset.gooseketInitialized === 'true' || typeof el.initialize !== 'function') return;
        if (el.classList.contains('newMySwiper5')) {
          Object.assign(el, { slidesPerView: 1, loop: true, pagination: { clickable: true }, observer: true, observeParents: true });
        } else {
          Object.assign(el, { slidesPerView: 'auto', spaceBetween: 12, pagination: { type: 'progressbar' }, observer: true, observeParents: true });
        }
        el.initialize();
        el.dataset.gooseketInitialized = 'true';
      });
    }
    function setupColors() {
      $$('.colorOptWrapAll', root).forEach(group => {
        if (group.dataset.gooseketColorsReady) return;
        const section = group.closest('.prdDetailWrap');
        if (!section) return;
        const buttons = $$('.colorOptDetail:not(.colorOptDetail2)', section);
        const labels = $$('.colorOptTxtWrap > .colorOptTxt', group);
        const panels = $$('li.colorOptWrap', group);
        if (!buttons.length || buttons.length !== panels.length) return;
        group.dataset.gooseketColorsReady = 'true';
        function select(index) {
          buttons.forEach((button, i) => {
            button.classList.toggle('focused', i === index);
            button.setAttribute('role', 'button');
            button.setAttribute('tabindex', '0');
            button.setAttribute('aria-label', `${labels[i]?.textContent.trim() || `색상 ${i + 1}`} 사진 보기`);
            button.setAttribute('aria-pressed', String(i === index));
          });
          labels.forEach((label, i) => { label.style.display = i === index ? 'block' : 'none'; });
          panels.forEach((panel, i) => { panel.style.display = i === index ? 'block' : 'none'; });
          requestAnimationFrame(() => panels[index]?.querySelector('swiper-container')?.swiper?.update());
        }
        buttons.forEach((button, i) => {
          button.addEventListener('click', () => select(i));
          button.addEventListener('keydown', event => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            select(i);
          });
        });
        select(0);
      });
    }
    function setupExtras() {
      $$('#extras_wrap > .extras', root).forEach(section => {
        if (section.dataset.gooseketAccordionReady) return;
        const header = $(':scope > .extrasTop', section);
        const bodies = $$(':scope > .extrasBottom', section);
        if (!header || !bodies.length) return;
        section.dataset.gooseketAccordionReady = 'true';
        header.setAttribute('role', 'button');
        header.setAttribute('tabindex', '0');
        function setOpen(open) {
          bodies.forEach(body => { body.style.display = open ? 'block' : 'none'; });
          header.setAttribute('aria-expanded', String(open));
        }
        header.addEventListener('click', () => setOpen(header.getAttribute('aria-expanded') !== 'true'));
        header.addEventListener('keydown', event => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          header.click();
        });
        setOpen(true);
      });
    }
    setupColors();
    setupExtras();
    loadSwiperElement().then(initializeSliders).catch(err => console.error('[GOOSEKET AIR+]', err));
  }

  function initAirFaq() {
    const faq = $('#prdDetailWrapAll_new .jp-air-faq');
    if (!faq || faq.dataset.faqReady === 'true') return;
    const topButton = $('.jp-air-faq-top', faq);
    const list = $('.jp-air-faq-list', faq);
    if (!topButton || !list) return;
    faq.dataset.faqReady = 'true';
    topButton.addEventListener('click', () => {
      const open = topButton.getAttribute('aria-expanded') !== 'true';
      topButton.setAttribute('aria-expanded', String(open));
      list.hidden = !open;
    });
    faq.addEventListener('click', event => {
      const question = event.target.closest('.jp-air-faq-question');
      if (!question || !faq.contains(question)) return;
      const answerId = question.getAttribute('aria-controls');
      const answer = answerId && document.getElementById(answerId);
      if (!answer) return;
      const open = question.getAttribute('aria-expanded') !== 'true';
      $$('.jp-air-faq-question[aria-expanded="true"]', faq).forEach(prev => {
        prev.setAttribute('aria-expanded', 'false');
        const prevId = prev.getAttribute('aria-controls');
        const prevAnswer = prevId && document.getElementById(prevId);
        if (prevAnswer) prevAnswer.hidden = true;
      });
      question.setAttribute('aria-expanded', String(open));
      answer.hidden = !open;
    });
  }

  whenReady(() => {
    // Independent guards keep one product feature from disabling others.
    const features = [
      init365PlusColorGallery, initClassicSliders, initSimpleImageColorChips,
      init365ColorSliders, init365WrappedColorSliders, initAccordions,
      initVideoAutoplay, initAirPlus, initAirFaq
    ];
    features.forEach(fn => {
      try { fn(); } catch (error) { console.error(`[GOOSEKET detail.js] ${fn.name}:`, error); }
    });
  });
})();
